
import $ from "jquery";

import StickyApiSideBar from "../StickyApiSideBar";
new StickyApiSideBar;

const ApiExplorer = require('./api.explorer').ApiExplorer;
//const Ace = require('ace-builds/src-noconflict/ace');
//const modeJavascript = require("ace-builds/src-noconflict/mode-javascript");
//const themeGithub = require('ace-builds/src-noconflict/theme-github');

export class ApiDoc {
    options = {

    };

    constructor(options) {
        this.options = $.extend(this.options, options);
        this.initExplorer();
        this.initSbmDocFilter();
        this.initSbmDeveloperApi();
    };

    initExplorer(){
        var apiExplorer = new ApiExplorer();
    }

    initSbmDocFilter() {
        var $sbmDocSrch = $('#api-doc-search');
        var $sbmList = $('.user-api-doc li[data-method]');

        $sbmDocSrch.on('keyup', function () {
            var value = $(this).val().toLowerCase();

            if (value === "") {
                $sbmList.show();
            } else {
                $sbmList.each(function () {
                    var target = $(this).data('method');
                    target = target.toLowerCase();
                    (target.indexOf(value) >= 0 ) ? $(this).show() : $(this).hide();
                });
            }
        });

        //scroll to id
        let apiSidebarMenuLinks = $(".stixty-content a");
        apiSidebarMenuLinks.click(function(e){
            apiSidebarMenuLinks.removeClass('active');
            $(this).addClass('active');
            let section = $(this).attr("href");
            let menuHeight = $(".header--settings-block").outerHeight();
            let distance = ($(section).offset().top - menuHeight) - 30;
            $("html, body").animate({scrollTop: distance}, 1000);
        });

    };

	initSbmDeveloperApi() {
		const STORAGE_KEY = "developer_api_active_tab";
		const BASE_PATH = window.location.pathname.split("/tab")[0]; // e.g. /en/api/developer-api

		// --- Core: activate tab + show panel ------------------------------------
		function activateTab($tab, pushHistory = true) {
			if (!$tab || !$tab.length) return;

			const tabId = $tab.data("tab") || $tab.attr("id")?.replace(/^tab-/, "");
			const panelId = $tab.find("a[aria-controls]").attr("aria-controls") || `panel-${tabId}`;
			let href = $tab.find("a[href]").attr("href") || "";

			// Fallback: if link doesn’t include /tab/, generate correct one
			if (!href || !href.includes("/tab/")) {
				href = `${BASE_PATH}/tab/${tabId}`;
			}

			// --- Tabs ---
			const $allTabs = $(".developer-tab-switch .tab-switcher--header-item");
			$allTabs.removeClass("active in")
				.attr({ "aria-selected": "false", tabindex: "-1" });
			$tab.addClass("active in")
				.attr({ "aria-selected": "true", tabindex: "0" });

			// --- Panels ---
			const $allPanels = $(".wrap-tabs.api--tabs .tab--item");
			$allPanels.removeClass("in").attr("hidden", true);
			const $panel = $("#" + panelId);
			if ($panel.length) $panel.addClass("in").removeAttr("hidden");

			// --- Save active tab ---
			try { localStorage.setItem(STORAGE_KEY, tabId); } catch {}

			// --- Update URL ---
			if (pushHistory) {
				const newUrl = new URL(href, window.location.origin);
				history.pushState({ tab: tabId }, "", newUrl.pathname);
			}
		}

		// --- Click handler ------------------------------------------------------
		$(document).on("click", ".developer-tab-switch .tab-switcher--header-item, .developer-tab-switch .tab-switcher--header-item a", function (e) {
			e.preventDefault();
			const $tab = $(this).closest(".tab-switcher--header-item");
			activateTab($tab, true);
		});

		// --- Keyboard navigation ------------------------------------------------
		$(document).on("keydown", ".developer-tab-switch .tab-switcher--header-item", function (e) {
			const $tabs = $(".developer-tab-switch .tab-switcher--header-item");
			const currentIndex = $tabs.index(this);
			let newIndex;

			switch (e.key) {
				case "ArrowRight": newIndex = (currentIndex + 1) % $tabs.length; break;
				case "ArrowLeft": newIndex = (currentIndex - 1 + $tabs.length) % $tabs.length; break;
				case "Home": newIndex = 0; break;
				case "End": newIndex = $tabs.length - 1; break;
				case "Enter":
				case " ":
					e.preventDefault();
					$(this).trigger("click");
					return;
				default: return;
			}
			e.preventDefault();
			$tabs.eq(newIndex).focus();
		});

		// --- Back/Forward navigation -------------------------------------------
		$(window).on("popstate", function (event) {
			const state = event.originalEvent?.state;
			if (state?.tab) {
				const $target = $(`.developer-tab-switch [data-tab='${state.tab}']`);
				if ($target.length) activateTab($target, false);
			}
		});

		// --- Initial load -------------------------------------------------------
		$(function () {
			let $tabToActivate = null;

			// From URL (/tab/<id>)
			const match = window.location.pathname.match(/\/tab\/([^/]+)/);
			if (match && match[1]) {
				$tabToActivate = $(`.developer-tab-switch [data-tab='${match[1]}']`);
			}

			// From localStorage
			if ((!$tabToActivate || !$tabToActivate.length) && localStorage.getItem(STORAGE_KEY)) {
				const saved = localStorage.getItem(STORAGE_KEY);
				$tabToActivate = $(`.developer-tab-switch [data-tab='${saved}']`);
			}

			// From Twig active
			if ((!$tabToActivate || !$tabToActivate.length)) {
				$tabToActivate = $(".developer-tab-switch .tab-switcher--header-item.active").first();
			}

			// Fallback: first
			if (!$tabToActivate || !$tabToActivate.length) {
				$tabToActivate = $(".developer-tab-switch .tab-switcher--header-item").first();
			}

			if ($tabToActivate && $tabToActivate.length) {
				activateTab($tabToActivate, false);
			}
		});
	}


	showTab(tabId) {
		const esc = (window.CSS && CSS.escape)
			? CSS.escape
			: (s) => String(s).replace(/[^a-z0-9_\-]/gi, '\\$&');

		const $container = $('.developer-tab-switch');
		const $tabs = $container.find('[role="tab"]');
		const $panels = $('.wrap-tabs.api--tabs .tab--item');

		// Tabs
		$tabs.attr({ 'aria-selected': 'false', tabindex: '-1' })
			.parent().removeClass('active');

		const $currentTab = $tabs.filter(`#tab-${esc(tabId)}`);
		$currentTab.attr({ 'aria-selected': 'true', tabindex: '0' })
			.parent().addClass('active');

		// Panels
		$panels.removeClass('in').attr('hidden', true);
		const $panel = $(`#panel-${esc(tabId)}`);
		if ($panel.length) {
			$panel.addClass('in').removeAttr('hidden');
		} else {
			console.warn('[API Tabs] Panel not found:', `#panel-${tabId}`);
		}
	}
}